/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Theme\Mui.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Friday September 6th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday September 6th 2024 3:27:20 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

export const muiStyle = {
    width:"100%",
    "& .MuiFormLabel-asterisk": {
        color: "red"
    },
    "& .MuiFormControlLabel-asterisk": {
        color: "red"
    }
};
